import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ExistingScribeModel } from 'js/types';

export enum MigrationStage {
  NotStarted = 'Not started',
  ReadingProjectFile = 'Reading project file',
  RebuildingTimelineAndCameras = 'Rebuilding timeline and cameras',
  ConvertingImagesAndText = 'Converting images and text',
  ConvertingAudio = 'Converting audio',
  FinalizingProject = 'Finalizing project',
  Complete = 'Complete',
  Error = 'Error'
}

export const CONVERSION_STAGE_LIST = [
  MigrationStage.ReadingProjectFile,
  MigrationStage.RebuildingTimelineAndCameras,
  MigrationStage.ConvertingImagesAndText,
  MigrationStage.ConvertingAudio,
  MigrationStage.FinalizingProject
];

const legacyProjectMigration = createSlice({
  name: 'legacyProjectMigration',
  initialState: {
    migrationStage: MigrationStage.NotStarted,
    imagesCount: 0,
    imagesConverted: 0,
    audioCount: 0,
    audioConverted: 0,
    conversionProgress: 0,
    convertedProject: null as ExistingScribeModel | null,
    convertedProjectDurationSeconds: null as number | null
  },
  reducers: {
    startMigration(state, _action: PayloadAction<File>) {
      state.migrationStage = MigrationStage.ReadingProjectFile;
    },
    setMigrationStage(state, action: PayloadAction<MigrationStage>) {
      state.migrationStage = action.payload;
    },
    setImagesCount(state, action: PayloadAction<number>) {
      state.imagesCount = action.payload;
    },
    convertedImage(state) {
      state.imagesConverted += 1;
    },
    setAudioCount(state, action: PayloadAction<number>) {
      state.audioCount = action.payload;
    },
    convertedAudio(state) {
      state.audioConverted += 1;
    },
    setConversionProgress(state, action: PayloadAction<number>) {
      state.conversionProgress = action.payload;
    },
    setConversionComplete(
      state,
      action: PayloadAction<{
        convertedProject: ExistingScribeModel;
        convertedProjectDurationSeconds: number;
      }>
    ) {
      state.conversionProgress = 100;
      state.convertedProject = action.payload.convertedProject;
      state.convertedProjectDurationSeconds = action.payload.convertedProjectDurationSeconds;
      state.migrationStage = MigrationStage.Complete;
    },
    reset(state) {
      state.migrationStage = MigrationStage.NotStarted;
      state.imagesCount = 0;
      state.imagesConverted = 0;
      state.audioCount = 0;
      state.audioConverted = 0;
      state.conversionProgress = 0;
      state.convertedProject = null;
      state.convertedProjectDurationSeconds = null;
    },
    migrationError(state, _action: PayloadAction<string>) {
      state.migrationStage = MigrationStage.Error;
    }
  }
});

export const {
  startMigration,
  setMigrationStage,
  setImagesCount,
  convertedImage,
  convertedAudio,
  setConversionProgress,
  setConversionComplete,
  setAudioCount,
  reset,
  migrationError
} = legacyProjectMigration.actions;
export const { name: reducerName } = legacyProjectMigration;
export default legacyProjectMigration.reducer;
